import { weaponsEn } from '../../weapons/locales/en.ts'

export const buildPresetsEn = {
  names: weaponsEn.names,
  stages: {
    opening: 'Opening',
    forest: 'Forest',
    mid_push: 'Towers',
    late_defense: 'Goose',
    endgame: 'Tree',
    custom: 'Custom',
  },
  manager: {
    personalTitle: 'My stage presets',
    personalDescription: 'Choose one saved build for each stage. Towers becomes the raid default; presets follow you across guilds.',
    guildTitle: 'Guild stage presets',
    guildDescription: 'Create shared stage loadouts. Towers becomes the raid default when a preset is applied.',
    count: (used: number, limit: number) => `${used} / ${limit} presets`,
    add: 'Add preset',
    empty: 'No stage presets yet.',
    noBuilds: 'Create at least one regular two-weapon build before adding a stage preset.',
    name: 'Preset name',
    namePlaceholder: 'For example: Main GvG setup',
    build: 'Build',
    buildNumber: (index: number) => `Build ${index}`,
    buildWithWeapons: (index: number, first: string, second: string) => `Build ${index}: ${first} + ${second}`,
    selectBuild: (stage: string) => `Select build for ${stage}`,
    edit: 'Edit',
    remove: 'Remove',
    save: 'Save preset',
    create: 'Create preset',
    cancel: 'Cancel',
    invalid: 'Enter a name and choose a two-weapon build for every stage.',
    removeConfirm: (name: string) => `Remove stage preset “${name}”?`,
    loading: 'Loading stage presets…',
  },
  selector: {
    title: 'Stage presets',
    hint: 'Towers sets the default; other stages apply as changes',
    personal: 'Personal',
    guild: 'Guild',
    active: 'Applied',
    apply: (name: string) => `Apply stage preset ${name}`,
  },
}
